import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell, Trash2 } from 'lucide-react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';

const initialNotifications = [
  {
    id: 1,
    title: 'Guest Verified',
    message: 'Chinedu Okafor was successfully verified using NIN.',
    time: '2 hours ago',
    read: false,
  },
  {
    id: 2,
    title: 'Verification Failed',
    message: 'Ngozi Adeyemi’s verification failed. Please review.',
    time: '5 hours ago',
    read: false,
  },
  {
    id: 3,
    title: 'Wallet Top-up',
    message: 'Your wallet was topped up with 50,000 units.',
    time: '1 day ago',
    read: true,
  },
  {
    id: 4,
    title: 'Watchlist Alert',
    message: 'Suspicious activity detected for Ibrahim Lawal.',
    time: '2 days ago',
    read: false,
  }
];

export default function NotificationsPage({ darkMode, setDarkMode }) {
  const navigate = useNavigate();
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [notifications, setNotifications] = useState(initialNotifications);
  const [filter, setFilter] = useState('all');

  const handleClearAll = () => {
    setNotifications([]);
  };

  const markAllAsRead = () => {
    setNotifications(prev => prev.map(n => ({ ...n, read: true })));
  };

  const toggleRead = (id) => {
    setNotifications(prev => prev.map(n =>
      n.id === id ? { ...n, read: !n.read } : n
    ));
  };

  const filteredNotifications = notifications.filter(n => {
    if (filter === 'all') return true;
    if (filter === 'read') return n.read;
    if (filter === 'unread') return !n.read;
    return true;
  });

  return (
    <div className="d-flex vh-100 bg-light overflow-hidden">
      <Sidebar 
        active="notification"
        mobileSidebarOpen={mobileSidebarOpen}
        setMobileSidebarOpen={setMobileSidebarOpen}
      />

      <div className="flex-grow-1 d-flex flex-column">
        <Header 
          darkMode={darkMode} 
          setDarkMode={setDarkMode} 
          toggleSidebar={() => setMobileSidebarOpen(!mobileSidebarOpen)} 
          notifications={notifications.length}
        />

        <main className="flex-grow-1 overflow-auto p-3 p-md-4">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="fw-bold m-0 cool-font">Notifications</h4>
            <div className="d-flex gap-2">
              <button className="btn btn-outline-danger btn-sm" onClick={handleClearAll}>
                <Trash2 size={18} className="me-1" />
                Clear All
              </button>
              <button className="btn btn-outline-primary btn-sm" onClick={markAllAsRead}>
                Mark All Read
              </button>
              <select
                className="form-select form-select-sm"
                style={{ width: 'auto' }}
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
              >
                <option value="all">All</option>
                <option value="read">Read</option>
                <option value="unread">Unread</option>
              </select>
            </div>
          </div>

          {filteredNotifications.length === 0 ? (
            <div className="text-center text-muted mt-5">
              <Bell size={48} className="mb-3" />
              <p className="fs-5">No notifications found</p>
              <p className="small">You’re all caught up!</p>
            </div>
          ) : (
            <ul className="list-unstyled m-0">
              {filteredNotifications.map(({ id, title, message, time, read }) => (
                <li 
                  key={id} 
                  className="bg-white rounded p-3 mb-3 d-flex align-items-start gap-3"
                  style={{ borderLeft: '4px solid #0D6EFD' }}
                >
                  <div className="flex-shrink-0">
                    <Bell color="#0D6EFD" size={20} />
                  </div>

                  <div className="flex-grow-1">
                    <h6 className="fw-bold mb-1 text-truncate d-flex justify-content-between align-items-center">
                      {title}
                      <button
                        className={`btn btn-sm ${read ? 'btn-outline-secondary' : 'btn-outline-success'}`}
                        onClick={() => toggleRead(id)}
                      >
                        {read ? 'Unread' : 'Mark Read'}
                      </button>
                    </h6>
                    <p className="mb-1 text-muted small">{message}</p>
                    <small className="text-secondary">{time}</small>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </main>
      </div>
    </div>
  );
}
